import { Box, TableCell, useTheme } from '@mui/material';
import React from 'react';


export interface CustomTableCellProps {
  children: JSX.Element;
  removeBR?: boolean;
  borderLeft?: boolean;
}

export default function CustomTableCell({ children, removeBR, borderLeft }: CustomTableCellProps) {
  // const { } = useCustomTableCell();
  const theme = useTheme()
  return (
    <TableCell align='center' sx={{ p: 0 }} data-testid='customTableCell-render-test'>
      <Box
        borderRight={!removeBR ? `1px solid ${theme.palette.greyScale[100]} !important` : 'none'}
        borderLeft={borderLeft ? `1px solid ${theme.palette.greyScale[100]} !important` : 'none'}
        color={theme.palette.greyScale[400]}
        px={1}
      >
        {children}
      </Box>
    </TableCell>
  )
}
